import { lightTheme } from './lightTheme'
import { darkTheme } from './darkTheme'

export const theme = (dark) => (dark? darkTheme: lightTheme)